const UserManagementUploadFileSelector = ({
  UserManagementUploadFileStore: { UserManagementUploadFile }
}) => UserManagementUploadFile;

export default UserManagementUploadFileSelector;
